import { Api } from '@axiom/ui';
import type { Candidate, CandidateProfile } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateProfileApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readCandidateProfile(candidateId: Candidate['id']) {
    return super.read<{ data: CandidateProfile }>({
      endpoint: `/candidates/${candidateId}/profile`,
      method: 'GET',
    });
  }

  async refreshCandidateProfile(candidateId: Candidate['id']) {
    return super.invalidate(`/candidates/${candidateId}/profile`);
  }
}

export const CandidateProfileApi = new CandidateProfileApiClass();
